import { ACTIVE_QUIZ_CHANGE, ADD_QUIZZES, ASSOCIATE_ITEM_ANALYSES, ASSOCIATE_QUIZ_ANALYSIS, ASSOCIATE_QUIZ_ENTRIES, DISASSOCIATE_QUIZ_ENTRY } from '@instructure/quiz-common';
export var addQuizzes = function addQuizzes(quizzes) {
  return {
    type: ADD_QUIZZES,
    payload: quizzes
  };
};
export var newActiveQuiz = function newActiveQuiz(activeQuizId) {
  return {
    type: ACTIVE_QUIZ_CHANGE,
    payload: activeQuizId
  };
};
export var associateItemAnalyses = function associateItemAnalyses(quizId, itemAnalyses) {
  return {
    type: ASSOCIATE_ITEM_ANALYSES,
    payload: {
      quizId: quizId,
      itemAnalyses: itemAnalyses
    }
  };
};
export var associateQuizAnalysis = function associateQuizAnalysis(quizId, quizAnalysis) {
  return {
    type: ASSOCIATE_QUIZ_ANALYSIS,
    payload: {
      quizId: quizId,
      quizAnalysis: quizAnalysis
    }
  };
};
export var associateQuizEntries = function associateQuizEntries(quizId, quizEntries) {
  return {
    type: ASSOCIATE_QUIZ_ENTRIES,
    payload: {
      quizId: quizId,
      quizEntries: quizEntries
    }
  };
};
export var disassociateQuizEntry = function disassociateQuizEntry(quizId, quizEntryId) {
  return {
    type: DISASSOCIATE_QUIZ_ENTRY,
    payload: {
      quizId: quizId,
      quizEntryId: quizEntryId
    }
  };
};